
import { ArrowDownUp, TrendingUp, Star, Clock } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface SortSelectProps {
  sortBy: string;
  setSortBy: (value: string) => void;
}

export const SortSelect = ({ sortBy, setSortBy }: SortSelectProps) => {
  return (
    <Select value={sortBy} onValueChange={setSortBy}>
      <SelectTrigger className="w-[180px]">
        <SelectValue placeholder="Sort by" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="recent">
          <span className="flex items-center">
            <Clock className="mr-2 h-4 w-4" />
            Most Recent
          </span>
        </SelectItem>
        <SelectItem value="popular">
          <span className="flex items-center">
            <Star className="mr-2 h-4 w-4" />
            Most Popular
          </span>
        </SelectItem>
        <SelectItem value="returns">
          <span className="flex items-center">
            <TrendingUp className="mr-2 h-4 w-4" />
            Highest Returns
          </span>
        </SelectItem>
        <SelectItem value="price-low">
          <span className="flex items-center">
            <ArrowDownUp className="mr-2 h-4 w-4" />
            Price: Low to High
          </span>
        </SelectItem>
        <SelectItem value="price-high">
          <span className="flex items-center">
            <ArrowDownUp className="mr-2 h-4 w-4 rotate-180" />
            Price: High to Low
          </span>
        </SelectItem>
      </SelectContent>
    </Select>
  );
};
